import { RequiredInputType } from '@libs/ui-lib';
import { AddNewTreatmentData, RequiredInputConfig, TeethSelectorMode, TeethSelectorResult } from '@libs/charting';
import { SurfaceSelectorResult } from '../../surface-selector-dialog';

export function determineTeethSelectorMode(requiredInputType?: RequiredInputType, editTreatment?: boolean): TeethSelectorMode {
  switch (requiredInputType) {
    case RequiredInputType.Tooth:
    case RequiredInputType.Surface: {
      return editTreatment ? TeethSelectorMode.SingleTooth : TeethSelectorMode.Full;
    }
    case RequiredInputType.Range: {
      return TeethSelectorMode.Range;
    }
    case RequiredInputType.Quadrant: {
      return TeethSelectorMode.Quadrant;
    }
    case RequiredInputType.Arch: {
      return TeethSelectorMode.Arch;
    }
    default: {
      return TeethSelectorMode.Full;
    }
  }
}

export function mapRequiredInputDialogResult(treatment: AddNewTreatmentData, result: TeethSelectorResult): AddNewTreatmentData[] {
  if (result.selectedArches.length > 0) {
    return [...result.selectedArches].flatMap((arch) => {
      return mapRequiredInputData(treatment, result, { arch });
    });
  }
  if (result.selectedQuadrants.length > 0) {
    return [...result.selectedQuadrants].flatMap((quadrant) => {
      return mapRequiredInputData(treatment, result, { quadrant });
    });
  }
  if (result.selectedTeeth.length > 0) {
    return [...result.selectedTeeth].flatMap((position) => {
      return mapRequiredInputData(treatment, result, { position });
    });
  }
  return mapRequiredInputData(treatment, result, { position: result.selectedTeeth[0] });
}

export function mapRequiredInputData(
  treatment: AddNewTreatmentData,
  result: TeethSelectorResult,
  { position, quadrant, arch }: RequiredInputConfig,
): AddNewTreatmentData[] {
  if (position) {
    return [
      {
        ...treatment,
        requiredInputData: { ...treatment.requiredInputData, position },
      },
    ];
  }
  if (result.selectedTeeth.length > 0) {
    return [
      {
        ...treatment,
        requiredInputData: {
          ...treatment.requiredInputData,
          positions: result.selectedTeeth,
          range: `${result.selectedTeeth[0]}-${result.selectedTeeth.at(-1)}`,
        },
      },
    ];
  }
  if (quadrant) {
    return [
      {
        ...treatment,
        requiredInputData: { ...treatment.requiredInputData, quadrants: [quadrant] },
      },
    ];
  }
  if (arch) {
    return [
      {
        ...treatment,
        requiredInputData: { ...treatment.requiredInputData, arches: [arch!] },
      },
    ];
  }
  return [treatment];
}

export function isSurfaceSelectorResult(result: TeethSelectorResult | SurfaceSelectorResult): result is SurfaceSelectorResult {
  return 'selectedTeethWithSurface' in result;
}
